import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Marquee from "../components/Marquee"
import { ScrollTrigger } from "../libraries/gsap"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class TradeForm extends Component {
  constructor(obj) {
    super(obj)

    this.searching = false
    this.stateSearch = qs(".search-wrapper", this.el)
    this.dropdown = qs(".dropdown", this.el)
    this.stateInput = qs(".state-input", this.el)
    this.searchInput = qs(".dropdown-search-input", this.el)
    this.submitButton = qs(".join-trade-program", this.el)

    this.form = qs("form", this.el)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    this.success = qs(".success-message", this.el)
    this.error = qs(".error-message", this.el)
  }

  animate() {
    const title = qsa(".left .char-1", this.el)
    const items = qsa(".right > div", this.el)

    gsap.from(title, {
      stagger: 0.05,
      autoAlpha: 0,
      duration: 1.2,
      y: "100%",
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    items.forEach(item => {
      gsap.from(item, {
        stagger: 0.1,
        autoAlpha: 0,
        duration: 1.2,
        y: 100,
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
        },
      })
    })
  }

  on() {
    // this.form.addEventListener("submit", this.onSubmit)
    window.addEventListener("click", this.onClick)
    this.submitButton.addEventListener("click", this.onClickSubmit)
    this.stateSearch.addEventListener("click", this.toggleSearchState)
    this.dropdown.addEventListener("click", this.selectOption)
    this.searchInput.addEventListener("input", this.filterOptions)
  }

  onClickSubmit = () => {
    const items = qsa(".dropdown-item", this.dropdown)

    const isValid = Array.from(items).some(item => {
      return item.textContent.trim() === this.stateInput.value
    })

    if (isValid === false) {
      this.stateInput.removeAttribute("readonly")

      setTimeout(() => {
        this.stateInput.setAttribute("readonly", true)
      }, 1000)
      return
    }
  }

  // onSubmit = e => {
  //   e.preventDefault()

  //   console.log("submit")

  //   if (this.stateInput.value === "") {
  //     return
  //   }

  //success

  // this.success.style.display = 'block'
  // this.error.style.display = 'none'
  // this.renderer.smooth.update()

  // // error

  // this.success.style.display = 'none'
  // this.error.style.display = 'block'
  // this.renderer.smooth.update()
  // }

  filterOptions = () => {
    const searchTerm = this.searchInput.value.toLowerCase()
    const items = qsa(".dropdown-item", this.dropdown)

    items.forEach(item => {
      const text = item.textContent.toLowerCase()
      const matches = text.includes(searchTerm)

      item.style.display = matches ? "block" : "none"
    })
  }

  onClick = e => {
    if (this.searching === false) return

    if (
      e.target.classList.contains("dropdown-item") ||
      e.target.classList.contains("search-wrapper") ||
      e.target.classList.contains("dropdown-search-input")
    ) {
      return
    } else {
      this.toggleSearchState()
    }
  }

  selectOption = e => {
    if (e.target.classList.contains("dropdown-item")) {
      this.stateInput.value = e.target.innerHTML
      this.toggleSearchState()
      this.stateSearch.classList.add("search-wrapper_active")
    }
  }

  toggleSearchState = () => {
    this.searching = !this.searching

    this.dropdown.classList.toggle("dropdown_active")
  }
}
